import { compose, head, values, omit } from 'ramda';

export const extractResourceData = (payload) => compose(head, values, omit(['meta']))(payload);
